// @ts-nocheck
import on from "../dom/on"
import toggle_class from "../dom/toggle_class"
import register_dom_update from "../navigation/register_dom_update"

const checks = [
  [0, 80, false],
  [130, 10000000, true],
]

const addscroll = () => {
  const scroll =
    document.body.style.position === "fixed"
      ? parseInt(document.body.style.top, 10) * -1
      : window.scrollY

  for (const [min, max, state] of checks) {
    if (scroll >= min && scroll <= max) {
      return toggle_class(document.body, { "scrolled-body": state })
    }
  }
}

on("scroll", null, addscroll)

register_dom_update({
  after: addscroll,
})
